export default __webpack_public_path__ + "static/media/elephant.1339bced.png";